import React, { Component, PropTypes } from 'react';
import { NitroHeading, NitroDivider, NitroLoading, NitroDefinition, NitroDrawer, NitroNavBar } from 'nitro-components';

import PastVehicles from './PastVehicles';

import {
  ALLOCATION_DETAIL_HEADING,
  ALLOCATED_INFO_DRIVER_PROFILE,
  ALLOCATED_INFO_DRIVER_PROFILE_FIRST_NAME,
  ALLOCATED_INFO_DRIVER_PROFILE_LAST_NAME,
  ALLOCATED_INFO_DRIVER_PROFILE_LICENSE_NO,
  ALLOCATED_INFO_DRIVER_PROFILE_ISSUING_STATE,
  ALLOCATED_INFO_DRIVER_PROFILE_EMAIL_ID,
  ALLOCATED_INFO_DRIVER_PROFILE_MOBILE_NO
} from '../content';

import styled from 'styled-components';

const DriverProfile = styled.section`
  margin: 30px 0 48px;
`;

class DriverDetails extends Component {
  render() {
    const { isOpen, close, fetchingDriverDetails, details } = this.props;

    const {
      DriverFirstName,
      DriverSurname,
      DriverLicense,
      IssuingState,
      DriverEmail,
      DriverMobile,
      VehicleAllocations
    } = details;

    const driverInfo = [
      {
        title: ALLOCATED_INFO_DRIVER_PROFILE_FIRST_NAME,
        description: DriverFirstName
      },
      {
        title: ALLOCATED_INFO_DRIVER_PROFILE_LAST_NAME,
        description: DriverSurname
      },
      {
        title: ALLOCATED_INFO_DRIVER_PROFILE_LICENSE_NO,
        description: DriverLicense
      },
      {
        title: ALLOCATED_INFO_DRIVER_PROFILE_ISSUING_STATE,
        description: IssuingState
      }
    ];

    const driverContactInfo = [
      {
        title: ALLOCATED_INFO_DRIVER_PROFILE_EMAIL_ID,
        description: DriverEmail,
        type: 'email'
      },
      {
        title: ALLOCATED_INFO_DRIVER_PROFILE_MOBILE_NO,
        description: DriverMobile
      }
    ];

    const driverDetails = fetchingDriverDetails
      ? <NitroLoading position="center" />
      : <section>
          <NitroNavBar
            variant="base-3"
            action={() => {
              this.props.back('currentDriver');
            }}
            label={ALLOCATION_DETAIL_HEADING}
            noBorder
            noPadding
          />

          <DriverProfile>
            <NitroHeading size="1" label={ALLOCATED_INFO_DRIVER_PROFILE} align="center" noMargin />
            <NitroDivider sidePanel />
            <NitroDefinition data={driverInfo} />
            <NitroDivider />
            <NitroDefinition data={driverContactInfo} />
            <NitroDivider />
          </DriverProfile>

          <PastVehicles list={VehicleAllocations || []} />

        </section>;

    return (
      <NitroDrawer
        isOpen={isOpen}
        padding="32px"
        width={460}
        close={() => {
          close('currentDriver');
        }}>
        {driverDetails}
      </NitroDrawer>
    );
  }
}

DriverDetails.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  back: PropTypes.func,
  fetchingDriverDetails: PropTypes.bool,
  details: PropTypes.object
};

export default DriverDetails;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/DriverDetails.js